import * as React from 'react';

export function MailIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M18.09,2.74c-.16-.16-.37-.24-.59-.24H2.5c-.22,0-.43.09-.59.24s-.24.37-.24.59v13.33c0,.22.09.43.24.59s.37.24.59.24h15c.22,0,.43-.09.59-.24.16-.16.24-.37.24-.59V3.33c0-.22-.09-.43-.24-.59ZM16.25,4.17l-6.2,5.55L3.76,4.17h12.49ZM16.67,15.83H3.33V6.01l6.73,5.93,6.61-5.92v9.8Z"
      />
    </svg>
  );
}

export function SlackIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M11.2,8.8c-.23-.23-.37-.55-.37-.88V3.75c0-.33.13-.65.37-.88.23-.23.55-.37.88-.37s.65.13.88.37c.23.23.37.55.37.88v4.17c0,.33-.13.65-.37.88-.23.23-.55.37-.88.37s-.65-.13-.88-.37ZM3.06,11.04c-.21.14-.37.33-.46.56s-.12.48-.07.72c.05.24.17.47.34.64.17.17.4.29.64.34.24.05.49.02.72-.07.23-.09.42-.25.56-.46.14-.21.21-.45.21-.69v-1.25h-1.25c-.25,0-.49.07-.69.21ZM17.13,8.8c.23-.23.37-.55.37-.88s-.13-.65-.37-.88c-.23-.23-.55-.37-.88-.37s-.65.13-.88.37c-.23.23-.37.55-.37.88v1.25h1.25c.33,0,.65-.13.88-.37ZM7.92,10.83c-.33,0-.65.13-.88.37-.23.23-.37.55-.37.88v4.17c0,.33.13.65.37.88.23.23.55.37.88.37s.65-.13.88-.37c.23-.23.37-.55.37-.88v-4.17c0-.33-.13-.65-.37-.88-.23-.23-.55-.37-.88-.37ZM16.25,10.83h-4.17c-.33,0-.65.13-.88.37-.23.23-.37.55-.37.88s.13.65.37.88c.23.23.55.37.88.37h4.17c.33,0,.65-.13.88-.37s.37-.55.37-.88-.13-.65-.37-.88c-.23-.23-.55-.37-.88-.37ZM7.92,6.67H3.75c-.33,0-.65.13-.88.37-.23.23-.37.55-.37.88s.13.65.37.88c.23.23.55.37.88.37h4.17c.33,0,.65-.13.88-.37s.37-.55.37-.88-.13-.65-.37-.88-.55-.37-.88-.37ZM12.78,15.21c-.21-.14-.45-.21-.69-.21h-1.25v1.25c0,.25.07.49.21.69.14.21.33.37.56.46.23.09.48.12.72.07.24-.05.47-.17.64-.34s.29-.4.34-.64c.05-.24.02-.49-.07-.72-.09-.23-.25-.42-.46-.56ZM7.92,2.5c-.33,0-.65.13-.88.37-.23.23-.37.55-.37.88s.13.65.37.88c.23.23.55.37.88.37h1.25v-1.25c0-.33-.13-.65-.37-.88-.23-.23-.55-.37-.88-.37Z"
      />
    </svg>
  );
}

export function HeadphonesIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M9.99934 3.33366C8.23123 3.33366 6.53555 4.03604 5.2853 5.28628C4.03506 6.53652 3.33268 8.23222 3.33268 10.0003H5.83268C6.27471 10.0003 6.69863 10.1759 7.01119 10.4885C7.32375 10.801 7.49935 11.225 7.49935 11.667V15.8337C7.49935 16.2757 7.32375 16.6996 7.01119 17.0122C6.69863 17.3247 6.27471 17.5003 5.83268 17.5003H3.33268C2.89065 17.5003 2.46673 17.3247 2.15417 17.0122C1.84161 16.6996 1.66602 16.2757 1.66602 15.8337V10.0003C1.66602 5.39783 5.39684 1.66699 9.99934 1.66699C14.6018 1.66699 18.3327 5.39783 18.3327 10.0003V15.8337C18.3327 16.2757 18.1571 16.6996 17.8445 17.0122C17.532 17.3247 17.108 17.5003 16.666 17.5003H14.166C13.724 17.5003 13.3001 17.3247 12.9875 17.0122C12.6749 16.6996 12.4993 16.2757 12.4993 15.8337V11.667C12.4993 11.225 12.6749 10.801 12.9875 10.4885C13.3001 10.1759 13.724 10.0003 14.166 10.0003H16.666C16.666 8.23222 15.9636 6.53652 14.7134 5.28628C13.4632 4.03604 11.7675 3.33366 9.99934 3.33366ZM3.33268 11.667V15.8337H5.83268V11.667H3.33268ZM14.166 11.667V15.8337H16.666V11.667H14.166Z"
      />
    </svg>
  );
}

export function SearchIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M15.0258 13.8475L18.595 17.4158L17.4158 18.595L13.8475 15.0258C12.5198 16.0902 10.8683 16.6691 9.16667 16.6667C5.02667 16.6667 1.66667 13.3067 1.66667 9.16667C1.66667 5.02667 5.02667 1.66667 9.16667 1.66667C13.3067 1.66667 16.6667 5.02667 16.6667 9.16667C16.6691 10.8683 16.0902 12.5198 15.0258 13.8475ZM13.3542 13.2292C14.4118 12.1416 15.0024 10.6837 15 9.16667C15 5.94333 12.3892 3.33333 9.16667 3.33333C5.94333 3.33333 3.33333 5.94333 3.33333 9.16667C3.33333 12.3892 5.94333 15 9.16667 15C10.6837 15.0024 12.1416 14.4118 13.2292 13.3542L13.3542 13.2292Z"
      />
    </svg>
  );
}
